<!--
Created by CHT 2019/9/21 10:21
-->
<template>
  <el-table
    fit
    border
    ref="allaTable"
    :data="crtData"
    height="100%"
    :style="{borderColor: borderColor}"
    @sort-change="sortChange"
    v-if="crtHeader.length && !loadingWidth"
    @selection-change="handleSelectionChange"
    class="all-available__table"
    @row-click="rowClick"
    @header-dragend="headerDragend"
    :row-style="rowStyle"
    :header-row-style="headerRowStyle"
    :cell-style="cellStyle"
    :header-cell-style="headerCellStyle"
    size="small">
    <el-table-column
      v-if="hasIndex"
      :fixed="lockAmount >= 1"
      type="index"
      width="50">
    </el-table-column>
    <el-table-column
      v-if="hasSelect"
      :fixed="hasIndex? lockAmount >= 2: lockAmount>=1"
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      v-for="(item, idx) in crtHeader"
      :width="item.type === FORM_ITEM__TABLE ? computeTableWidth(item) + 'px' : `200px` "
      :fixed="lockAmount >= idx + lockAmountDiff"
      :key="item.dataId"
      :column-key="item.dataId"
      :prop="item.dataId"
      :label="item[headerTitle]"
      :formatter="columnFormatter"
      :header-align="item.type !== FORM_ITEM__TABLE ? 'left': 'center'"
      :align="item.type !== FORM_ITEM__TABLE ? 'left': 'center'"
      :sortable="item.type !== FORM_ITEM__TABLE && sortable ? 'custom': false">
      <template v-if="item.type === FORM_ITEM__TABLE">
        <el-table-column
          v-for="tableField in item.tableFieldList"
          :width="`140px`"
          header-align="center"
          :key="tableField.dataId"
          :column-key="tableField.dataId"
          :prop="tableField.dataId"
          :label="tableField.fieldTitle"
          :formatter="subColumnFormatter">
        </el-table-column>
      </template>
    </el-table-column>
  </el-table>
  <div
    v-else-if="!crtHeader.length && loadingWidth"
    class="empty-background__container">
  </div>
</template>

<script>
  import {formatDate, selectPhoneNumberAndUrl} from "../../assets/js/Untis"
  import { ImagePreview } from 'vant'
  import {
    FORM_ITEM__ADDRESS,
    FORM_ITEM__ATTACHMENT,
    FORM_ITEM__CHECKBOX,
    FORM_ITEM__CURRENCY,
    FORM_ITEM__DATE,
    FORM_ITEM__DATE_RANGE,
    FORM_ITEM__DEPARTMENT,
    FORM_ITEM__DROPDOWN,
    FORM_ITEM__IMAGE,
    FORM_ITEM__IMAGE_CHOOSE,
    FORM_ITEM__LOCATION,
    FORM_ITEM__MEMBER,
    FORM_ITEM__RTF, FORM_ITEM__SIGNATURE,
    FORM_ITEM__SINGLE_CHOOSE, FORM_ITEM__SINGLE_LINE,
    FORM_ITEM__SLIDING_BLOCK,
    FORM_ITEM__SUMMARY,
    FORM_ITEM__TABLE,
    FORM_ITEM__YES_NO
  } from "../RyForm/types"

  function contrastType(val, type) {
    let typeString = null
    switch (type) {
      case 'string':
        typeString = '[object String]'
        break
      case 'number':
        typeString = '[object Number]'
        break
      case 'array':
        typeString = '[object Array]'
        break
      case 'object':
        typeString = '[object Object]'
        break
      default:
        break
    }
    return Object.prototype.toString.call(val) === typeString
  }

  export default {
    props: {
      header: {
        type: Array,
        default: () => [
          {
            dataId: '1',
            fieldName: 'x1',
            type: '',
            show: true
          },
          {
            fieldId: '2',
            fieldName: 'x2',
            type: '',
            show: true
          },
          {
            fieldId: '3',
            fieldName: 'x3',
            type: '',
            show: true
          }
        ]
      },

      headerTitle: {
        type: String,
        default: 'fieldTitle'
      },

      tableData: {
        type: Array,
        default: () => [
          // {"1": '2016-05-02', "2": '王小虎', "3": '上海市普陀区金沙江路 1518 弄'},
          // {"1": '2016-05-04', "2": '王小虎', "3": '上海市普陀区金沙江路 1517 弄'}
        ]
      },
      rowStyle: Function,
      headerRowStyle: Function,
      cellStyle: Function,
      headerCellStyle: Function,
      sortable: {
        type: Boolean,
        default: true
      },
      // 表格线条颜色
      borderColor: {
        type: String,
        default: '#EBEEF5'
      },

      // 是否有选择
      hasSelect: {
        type: Boolean,
        default: false
      },
      // 是否有序号
      hasIndex: {
        type: Boolean,
        default: false
      },
      // 锁定前几列
      lockAmount: {
        type: Number,
        default: 0
      }
    },
    data() {
      const allSubTable = this.header.filter(item => item.type === FORM_ITEM__TABLE)
      const tableChildrenIdList = []
      allSubTable.forEach(item => {
        if (item.tableFieldList && item.tableFieldList.length) {
          tableChildrenIdList.push(...item.tableFieldList.map(subItem => subItem.dataId))
        }
      })
      return {
        FORM_ITEM__TABLE,
        allSubTable,
        tableChildrenIdList,
        lockAmountDiff: (this.hasIndex && this.hasSelect) ? 3 : (this.hasIndex || this.hasSelect) ? 2 : 1,
        loadingWidth: true
      }
    },
    created() {
      this.$store.dispatch('actionFetchTableWidth', this.$store.state.formId)
        .then(widthInfo => {
        this.header.forEach(item => {
          if (item.type === FORM_ITEM__TABLE) {
            if (item.tableFieldList && item.tableFieldList.length) {
              item.tableFieldList.forEach(tItem => {
                let widthItem = widthInfo.filter(f => tItem.dataId === f.fieldId)[0]
                tItem.width = widthItem ? widthItem.fieldWidth : '120'
              })
            }
          } else {
            let widthItem = widthInfo.filter(f => item.dataId === f.fieldId)[0]
            item.width = widthItem ? widthItem.fieldWidth : '180'
          }
        })
      }).catch(console.error)
        .finally(() => {
          this.loadingWidth = false
        })
    },
    mounted() {
      this.$nextTick(() => {
        // 拦截单行文本中a标签的点击事件
        setTimeout(() => {
          const urlA = document.getElementById('urlA')
          if (urlA) {
            urlA.onclick = function (e) {
              e.stopPropagation()
            };
            urlA.onmousedown = function (e) {
              e.stopPropagation()
            };
            urlA.onmouseup = function (e) {
              e.stopPropagation()
            };
          }
        }, 3000)
      })
    },
    computed: {
      // current header
      crtHeader() {
        return this.header.filter(item => item.show)
      },
      // 重新计算数据
      crtData() {
        const dataList = []
        const allShowTable = this.header.filter(item => item.show && item.type === FORM_ITEM__TABLE)
        this.tableData.forEach(item => {
          let obj = {...item}
          const maxRowNum = Math.max(...allShowTable.map(table => (obj[table.dataId] || []).length))

          this.allSubTable.forEach(table => {
            let tableValue = obj[table.dataId] || []
            // 编辑子表单子列
            if (table.tableFieldList && table.tableFieldList.length) {
              table.tableFieldList.forEach(field => {
                obj[field.dataId] = []
                tableValue.forEach(valueItem => {
                  obj[field.dataId].push(valueItem[field.dataId] || null)
                })
                for (let i = obj[field.dataId].length; i < maxRowNum; i++) {
                  obj[field.dataId].push(null)
                }
              })
            }
          })
          dataList.push(obj)
        })
        return dataList
      },
      // header map
      headerMap() {
        let map = {}
        this.header.forEach(h => {
          map[h.dataId] = h
          if (h.type === FORM_ITEM__TABLE && h.tableFieldList) {
            h.tableFieldList.forEach(sub => {
              map[sub.dataId] = sub
            })
          }
        })
        return map
      }
    },
    methods: {
      // 格式化table内容
      columnFormatter(row, column, cellValue, index) {
        const field = this.headerMap[column.property]
        let h = this.$createElement
        return h('div', {
          staticClass: 'custom-cell'
        }, [h('div', {
            on: {
              click: () => {
                this.clickHandler(row)
              }
            },
            style: {
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
            },
          }
        ), this.commonRender(field, cellValue, h)])
      },
      // 格式化子表单内容
      subColumnFormatter(row, column, cellValue, index) {
        const field = this.headerMap[column.property]
        const h = this.$createElement
        return cellValue && cellValue.length ? h('div', cellValue.map(val => {
          return h('div', {
            staticClass: 'custom-sub-cell'
          }, [h('div', {
              on: {
                click: () => {
                  this.clickHandler(row)
                }
              },
              style: {
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
              },
            }
          ), this.commonRender(field, val, h)])
        })) : h('div', {
          staticClass: 'custom-cell'
        }, [this.isEmpty()])
      },
      // 各类型数据渲染
      commonRender(field, cellValue, h) {
        if (cellValue === null) {
          return this.isEmpty()
        }
        switch (field.type) {
          case FORM_ITEM__SINGLE_LINE: {
            if (contrastType(cellValue, 'string')) {
              const value = selectPhoneNumberAndUrl(cellValue)
              return h('div', {
                on: {
                  click: e => {
                    e.stopPropagation()
                  },
                }
              }, [
                h('div', {
                  domProps: {
                    innerHTML: value
                  }
                })
              ])
            } else {
              return this.isEmpty()
            }
          }
          // 是否
          case FORM_ITEM__YES_NO: {
            if (contrastType(cellValue, 'number')) {
              return !!cellValue ? '是' : '否'
            } else {
              return this.isEmpty()
            }
          }
          // 日期
          case FORM_ITEM__DATE : {
            if (contrastType(cellValue, 'number') && cellValue > 0) {
              if (field.dataType === 0) {
                return formatDate(cellValue)('yyyy/MM/dd')
              } else {
                return formatDate(cellValue)('yyyy/MM/dd HH:mm:ss')
              }
            } else {
              return this.isEmpty()
            }
          }
          // 起止时间
          case FORM_ITEM__DATE_RANGE: {
            if (contrastType(cellValue, 'array')) {
              if (cellValue.length) {
                if (field.dataType === 0) {
                  return `${formatDate(cellValue[0])('yyyy/MM/dd')}-${formatDate(cellValue[1])('yyyy/MM/dd')}`
                } else {
                  return `${formatDate(cellValue[0])('yyyy/MM/dd HH:mm:ss')}-${formatDate(cellValue[1])('yyyy/MM/dd HH:mm:ss')}`
                }
              } else {
                return this.isEmpty()
              }
            } else {
              return this.isEmpty()
            }
          }
          // 金额
          case FORM_ITEM__CURRENCY: {

            if (contrastType(cellValue, 'number')) {
              if (field.currencyType === 'DOLLAR') {
                return `$${cellValue}`
              } else {
                return `￥${cellValue}`
              }
            } else {
              return this.isEmpty()
            }
          }
          // 富文本
          case FORM_ITEM__RTF: {
            this.isEmpty()
          }
          // 滑块
          case  FORM_ITEM__SLIDING_BLOCK: {
            if (contrastType(cellValue, 'number')) {
              return `${cellValue}%`
            } else {
              return this.isEmpty()
            }
          }
          // 单选
          case FORM_ITEM__SINGLE_CHOOSE:
          case FORM_ITEM__DROPDOWN: {
            if (cellValue) {
              const filterField = field.options.filter(opt => {
                return opt.id === cellValue
              })[0]
              return filterField ? filterField.optionName : this.isEmpty()
            } else {
              return this.isEmpty()
            }
          }
          // 多选
          case FORM_ITEM__CHECKBOX: {
            if (contrastType(cellValue, 'array')) {
              return field.options
                .filter(opt => cellValue.includes(opt.id))
                .map(opt => opt.optionName)
                .join('、') || this.isEmpty()
            } else {
              return this.isEmpty()
            }
          }

          // 图片选项
          case FORM_ITEM__IMAGE_CHOOSE: {
            if (contrastType(cellValue, 'array')) {
              return this.isImageChoose(
                field.options
                  .filter(opt => cellValue.includes(opt.id))
                  .map(opt => ({
                    url: opt.optionImage,
                    content: opt.optionName
                  }))
              )
            } else {
              return this.isEmpty()
            }
          }
          // 图片
          case FORM_ITEM__IMAGE: {
            if (contrastType(cellValue, 'array')) {
              return this.isImages(
                cellValue.map(item => item.imgUrl)
              )
            } else {
              return this.isEmpty()
            }
          }
          // 签名
          case FORM_ITEM__SIGNATURE: {
            if (contrastType(cellValue, 'string')) {
              return this.isSign(cellValue)
            } else {
              return this.isEmpty()
            }
          }
          // 地址
          case FORM_ITEM__ADDRESS: {
            if (contrastType(cellValue, 'object')) {
              const {
                province,
                city,
                county,
                detailAddress
              } = cellValue
              let result = ''
              if (province || city || county || detailAddress) {
                result = `${province} ${city} ${county} ${detailAddress}`
              } else {
                result = this.isEmpty()
              }
              return result
            } else {
              return this.isEmpty()
            }
          }
          // 定位
          case FORM_ITEM__LOCATION: {
            if (contrastType(cellValue, 'string')) {
              return this.isNoHold()
            } else {
              return this.isEmpty()
            }
          }
          // 附件
          case FORM_ITEM__ATTACHMENT: {
            if (contrastType(cellValue, 'array')) {
              return cellValue.length ? h('div', {
                style: {
                  display: 'flex'
                }
              }, cellValue.map(file =>
                h('el-button', {
                  props: {
                    icon: 'el-icon-tickets',
                    type: 'text',
                    size: 'mini'
                  },
                  style: {
                    fontSize: '20px',
                    padding: 0,
                    color: '#333333',
                    lineHeight: '26px',
                    marginRight: '3px'
                  }
                })
              )) : this.isEmpty()
            } else {
              return this.isEmpty()
            }
          }
          // 选人、选部门
          case FORM_ITEM__DEPARTMENT:
          case FORM_ITEM__MEMBER: {
            if (contrastType(cellValue, 'object')) {
              return this.isMember(cellValue)
            } else {
              return this.isEmpty()
            }
          }
          // 数据汇总
          case FORM_ITEM__SUMMARY: {
            if (contrastType(cellValue, 'object')) {
              return cellValue.summaryValue
            } else {
              return this.isEmpty()
            }
          }
          default:
            return cellValue || this.isEmpty()
        }
      },
      // 为空渲染
      isEmpty() {
        const h = this.$createElement
        return h('el-alert', {
          props: {
            title: '-',
            type: 'info',
            closable: false,
            center: true
          },
          style: {
            padding: 0
          }
        })
      },
      // 联系人控件
      isMember({member = [], depart = [], role = []}) {
        const h = this.$createElement
        if (member.length || depart.length || role.length) {
          const getters = this.$store.getters
          return [
            ...member.map(userId => getters.userListMap[userId] ? getters.userListMap[userId].nickname : ''),
            ...depart.map(depId => getters.depListMap[depId] ? getters.depListMap[depId].depName : ''),
            ...role.map(roleId => getters.roleListMap[roleId] ? getters.roleListMap[roleId].roleName : '')
          ].join('、')
        } else {
          return this.isEmpty()
        }
      },
      // 图片选项渲染
      isImageChoose(opts) {
        const h = this.$createElement
        return opts.length ? h('div', {
          style: {
            display: 'flex'
          }
        }, opts.map(({url, content}) =>
          h('el-image', {
            props: {
              src: url,
              fit: 'cover'
            },
            style: {
              width: '30px',
              height: '30px',
              marginLeft: '3px',
              display: 'inline-block'
            }
          })
        )) : this.isEmpty()
      },
      // 图片渲染
      isImages(urls) {
        const h = this.$createElement
        return urls.length ? h('div', {
          style: {
            display: 'flex'
          }
        }, urls.map((url, idx) =>
          h('el-image', {
            props: {
              src: url,
              fit: 'cover'
            },
            on: {
              click: () => {
                ImagePreview({
                  images: urls,
                  startPosition: idx
                })
              }
            },
            style: {
              width: '30px',
              height: '30px',
              marginLeft: '3px',
              display: 'inline-block',
              border: '1px solid #e6e6e6'
            }
          })
        )) : this.isEmpty()
      },
      // 签名渲染
      isSign(url) {
        const h = this.$createElement
        return url ? h('el-image', {
          props: {
            src: url,
            fit: 'cover'
          },
          style: {
            width: '53px',
            height: '30px',
            marginLeft: '3px',
            display: 'inline-block',
            border: '1px solid #e6e6e6'
          }
        }) : this.isEmpty()
      },
      // 暂不支持
      isNoHold() {
        const h = this.$createElement
        return h('el-alert', {
          props: {
            title: '暂不支持',
            type: 'warning',
            closable: false,
            center: true
          },
          style: {
            padding: 0
          }
        })
      },
      // 子表单
      isTable(column, values) {
        const tableHeader = this.crtHeader.filter(h => {
          return h.dataId === column.property
        })[0]
        /*

          fit
          border
          ref="allaTable"
          :data="curData"
          height="100%"
          @sort-change="sortChange"
          v-if="crtHeader.length"
          class="all-available__table"
          @selection-change="handleSelectionChange"
          @row-click="rowClick"

         <el-table-column
            v-for="item in crtHeader"
            width="180px"
            :key="item.dataId"
            :prop="item.dataId"
            :label="item.fieldTitle"
            :formatter="columnFormatter"
            sortable="custom">
         </el-table-column>
         */
        if (
          values &&
          values.length &&
          tableHeader &&
          tableHeader.tableFieldList &&
          tableHeader.tableFieldList.length
        ) {
          const h = this.$createElement
          return h('el-table', {
            props: {
              fit: true,
              border: true,
              data: values,
            }
          }, tableHeader.tableFieldList.map(item => {
            return h('el-table-column', {
              width: '180px',
              props: item.dataId,
              label: item.fieldTitle,
              formatter: this.columnFormatter
            })
          }))
        } else {
          return this.isEmpty()
        }
      },
      // 正反序
      sortChange({column, prop, order}) {
        if (order === 'ascending') {
          this.$emit('sorting', {[prop]: 1})
        } else if (order === 'descending') {
          this.$emit('sorting', {[prop]: -1})
        } else {
          this.$emit('sorting', {})
        }
      },
      // 勾选数据
      handleSelectionChange(selection) {
        this.$emit('selectionChange', selection)
      },
      // 表格每一个格子加的点击事件
      clickHandler(row) {
        this.$emit('rowClick', row)
      },
      // 当某一行被点击时会触发该事件 ---不用了
      rowClick(row, column, event) {
        // event.stopPropagation()
        // console.log(column)
        // console.log(event)
        // this.$emit('rowClick', row)
      },
      // 清空select
      clearSelection() {
        this.$refs.allaTable.clearSelection()
      },
      // 计算子表单整体宽度
      computeTableWidth(item) {
        let width = 0
        if (item.tableFieldList && item.tableFieldList.length) {
          item.tableFieldList.forEach(f => {
            width += 140
          })
        } else {
          width = 240
        }
        return width
      },
      // 列宽拖动改变
      headerDragend(newWidth, oldWidth, column, event) {
        this.$store.dispatch('actionSettingTableWidth', {
          companyId: this.$store.state.companyId,
          formId: this.$store.state.formId,
          appId: this.$store.state.appId,
          fieldId: column.columnKey,
          fieldWidth: String(newWidth)
        }).catch(console.error)
      },

      // 该行是否被选中
      toggleRowSelection(instanceIdList) {
        this.$nextTick(() => {
          setTimeout(() => {
            const rows = []
            instanceIdList.forEach(id => {
              const row = this.crtData.filter(item => item.instanceId === id)[0]
              if (row) rows.push(row)
            })
            if (rows) {
              rows.forEach(row => {
                if (this.$refs.allaTable) {
                  this.$refs.allaTable.toggleRowSelection(row, true);
                }
              });
            } else {
              if (this.$refs.allaTable) {
                this.$refs.allaTable.clearSelection();
              }
            }
          }, 1000)
        })
      }
    }
  }
</script>

<style lang="less">
  .all-available__table {
    display: inline-block;
    min-width: 360px;

    .cell {
      padding: 0;

      .custom-cell {
        width: 180px;
        padding-left: 10px;
        padding-right: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
        box-sizing: border-box;
      }

      .custom-sub-cell {
        width: 120px;
        min-height: 23px;
        line-height: 23px;
        padding: 8px 10px;
        border-bottom: 1px solid #e6e6e6;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
        box-sizing: border-box;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }
      }
    }

    .el-table__header-wrapper,
    .el-table__fixed-header-wrapper {
      thead {
        th {
          &:last-child {
            border-bottom: none;
          }
        }

        .cell {
          position: relative;
          height: 24px;
          line-height: 24px;
          padding-right: 26px;
          font-weight: normal;
          color: #495060;
        }

        .caret-wrapper {
          position: absolute;
          right: 2px;
          top: -4px;
        }
      }
    }

    .el-image-viewer__wrapper {
      .el-image-viewer__close {
        color: #ffffff;
        background-color: #606266;
      }

      .el-image-viewer__mask {

      }
    }
  }

  .rtf-check-btn {
    z-index: 1;
  }

  .attachment-over-view-popper {
    .el-form-item {
      margin-bottom: 0;
    }

    .el-form {
      label {
        width: 80px;
        color: #99a9bf;
        float: left;
      }
    }

    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;

      a {
        word-break: break-all;
        cursor: pointer;
      }
    }
  }
</style>
